export default {
  fr : {
    Title : 'Décarbonisation',
    Admin: {
      Title : "Admin"
    },
    Report : 'Rapport',
    ComplexityParameter:  {
      Title: "Facteurs de corrélation d'énergie par tonne déplacée",
      Name : 'Nom',
      Constant : 'Constante',
      Exponent : 'Exposant',
      Formula : 'Formule',
      ConfirmDelete : "Souhaitez-vous réellement supprimer ce facteur?",
      DeletedConfirmation : "Le facteur a été correctement supprimé",
      AddNew : 'Nouveau paramètre',
      Edit : "Édition d'un paramètre"
    },
    EnergySourceUnitConversion:  {
      Title: "Conversions d'unités de sources énergétique",
      Name : 'Nom',
      ConfirmDelete : "Souhaitez-vous réellement supprimer cette conversion?",
      EnergySourceUnitConversionDeleted : "La conversion a été correctement supprimée",
      AddNew : 'Nouvelle conversion',
      Edit : 'Modifier la convesion',
      EnergySource: 'Source énergétique',
      GramPerLiter: 'CO2 g/l',
      GJPerCubicMeter: 'GJ/m³'
    },
    EnergySupplyTemplate:  {
      Title: "Modèles d'approvisionnement en énergie",
      Name : 'Nom',
      ConfirmDelete : "Souhaitez-vous réellement supprimer ce modèle d'approvisionnement en énergie?",
      DeletedConfirmation : "Le modèle d'approvisionnement en énergie a été correctement supprimé",
      AddNew : 'Nouveau modèle',
      Edit : "Édition d'un modèle",
      Tab1Title: "Modèle",
      Tab2Title: "Ratios par année/source",
      Tab2Unavailable: "Ratios par année/source n'est pas disponible tant que le modèle n'est pas sauvegardé"
    },
    EnergyTypeRatio:  {
      Title: "Ratio par source d'énergie",
      Rate : 'Taux (%)',
      Year : 'Année',
      StartYear : 'Année de début',
      EndYear : 'Année de fin',
      EnergySource : "Source d'énergie",
      Total : "Total",
      ConfirmDelete : "Souhaitez-vous réellement supprimer ce ratio?",
      DeletedConfirmation : "Le ratio a été correctement supprimé",
      BatchAddTitle: "Ajouter des ratios annuels",
      AddNew : 'Nouveau ratio',
      Edit : "Édition d'un ratio"
    },
    GridEfficiencyTemplate:  {
      Title: "Modèles d'intensité électrique",
      Name : 'Nom',
      ConfirmDelete : "Souhaitez-vous réellement supprimer ce modèle d'intensité électrique?",
      DeletedConfirmation : "Le modèle d'intensité électrique a été correctement supprimé",
      AddNew : 'Nouveau modèle',
      Edit : "Édition d'un modèle",
      Tab1Title: "Modèle",
      Tab2Title: "Ratios d'émissions",
      Tab2Unavailable: "Ratios d'émissions n'est pas disponible tant que le modèle n'est pas sauvegardé"
    },
    GridEfficiency:  {
      Title: "Taux d'émissions",      
      Rate : 'Taux (kg/kWh)',
      StartYear : 'Année de début',
      EndYear : 'Année de fin',
      ConfirmDelete : "Souhaitez-vous réellement supprimer ce taux?",
      DeletedConfirmation : "Le taux a été correctement supprimé",
      AddNew : 'Nouveau taux',
      Edit : "Modifier le taux",
      NoRates: "Aucun taux n'a été défini"
    },
    EnergySourcesEnum: {
      '0': "Énergie électrique",
      '1': "Diesel - Prime Mover",
      '2': "Diesel - Équipement",
      '3': "Gasoline",
      '4': "Gaz naturel"
    },
    CalculationMethodEnum: {
      '0': "Corrélation d'énergie par tonne déplacée",
      '1': "Importation manuelle de la consommation énergétique",
      '2' : "Importation manuelle des tonnes déplacées"
    },
    Publish: {
      SendingRequest : "Envoi de la requête...",
      RequestSent : "Requête envoyé",
      Calculation : "Calcul en cours..."
    },
    EnergyScenarios: {
      Title: "Scénarios énergétiques",
      Edit: "Modifier",
      Name: "Nom",
      ConfirmDelete : "Souhaitez-vous réellement supprimer ce scénario?",
      DeletedConfirmation : "Le scénario a été correctement supprimé",
      Compilation: "Compilation",
      BaseInfoTab: "Informations de base",
      LOMParametersTab: "Paramètres des LOM",
      AddNew: "Nouveau scénario",
      LOMParametersEditionTab: "Configuration",
      LOMParametersToCreate: "Paramètres à définir",
      LOMName: "Entité",
      LOMParametersCreated: "Paramètres créés",
      EnergySupplyTemplate: "Modèle d'approvisionnement en énergie",
      GridEfficiencyTemplate: "Intensité carbone de l'électricité",
      ComplexityParameter: "Facteur de corrélation",
      CalculationMethod: "Méthode de calcul",
      EnergySimulation: "Consommation énergétique projetée",
      Year: "Année",
      EnergyConsumption: "Consommation énergétique du projet (GJ)",
      Tonnage: "Tonnes déplacées",
      ComplexityFactor: "Facteur de complexité",
      EnergyDemand: "Consommation énergétique (GJ)",
      KWhEquivalent: "kWh Équivalent (hr)",
      MwEquivalent: "MW Équivalent (hr)",
      LitersEquivalent: "Litres Équivalent",
      CO2Factor: "CO² - facteurs",
      CO2Equivalent: "CO²",
      AllParametersDefined : "Tous les paramètres ont été définis",
      EmptyParametersDefined : "Aucun paramètre n'a encore été défini",
      UploadTemplateTotalEnergyFile : "Obtenir le modèle avec l'énergie totale",
      UploadTemplateMovedTonsFile : 'Obtenir le modèle avec les tonnes déplacées',
      UploadWarning : "Le téléversement d'un fichier de Consommation énergétique écrasera toutes les entrées de Consommation énergétique",
      UploadFile : "Téléverser le fichier de Consommation énergétique",
      UploadInvalidFileError : "Fichier de téléversement invalide",
      ParameterMustBeCreated : "Le paramètre doit être sauvegardé avant de téléverser le fichier de Consommation énergétique",
      UploadSuccess : "Le fichier de Consommation énergétique a été correctement importé",
      UploadFails : "Erreur d'importation",
      UploadFailText : "Le fichier possède un format inattendu.  Veuillez télécharger le modèle correspondant et réessayer"
    }
  }
}
